import i18n from '@/libs/i18n'
import useEntityCrud from '@/composable/useEntityCrud'
import useErrorManager from '@/composable/useErrorManager'
import store from '@/store'

export default function useSubscriptionsList() {
  const MODULE_NAME = 'subscriptions'
  function convertResource(resource) {
    return {
      ...resource,
      subscriptionLink: { name: `pages-${MODULE_NAME}-edit`, params: { id: resource._id } },
    }
  }

  const ENDPOINT = 'subscription'

  const entity = useEntityCrud(MODULE_NAME, ENDPOINT, convertResource)
  const errorManager = useErrorManager()

  // Table Handlers
  const tableColumns = [
    { key: 'email', label: i18n.t('general.email') },
    {
      key: 'createdAt', label: i18n.t('general.createdAt'), type: 'dateTime', sortable: true,
    },
    {
      key: 'updatedAt', label: i18n.t('general.updatedAt'), type: 'dateTime', sortable: true,
    },
    { key: 'actions', label: i18n.t('general.actions'), sortable: false },
  ]

  const exportExcel = () => {
    const queryParams = { responseType: 'blob' }
    return store
      .dispatch('crud/getExcel', {
        queryParams,
        endpoint: 'subscription/excel',
      })
      .then(response => response)
      .catch(err => {
        errorManager(err)
      })
  }

  return {
    ...entity,
    convertResource,
    exportExcel,
    tableColumns,
  }
}
